import Phaser from 'phaser';
import { COLORS, GAME_W, GAME_H, intToHex } from '../utils/constants';

export default class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  create() {
    this.createGradientTexture('gradient', COLORS.cyan, COLORS.blue, 64, 64);
    this.createGradientTexture('gradient2', COLORS.purple, COLORS.pink, 64, 64);
    this.createGradientTexture('gradient3', COLORS.bgDark, COLORS.bg, 128, 128, true);
    this.createGlowParticle('glow', 6);

    this.scene.start('PreloadScene');
  }

  private createGradientTexture(
    key: string,
    color1: number,
    color2: number,
    width: number,
    height: number,
    horizontal = false
  ) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d')!;

    const gradient = horizontal
      ? ctx.createLinearGradient(0, 0, width, 0)
      : ctx.createLinearGradient(0, 0, 0, height);
    gradient.addColorStop(0, intToHex(color1));
    gradient.addColorStop(1, intToHex(color2));

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    const tex = this.textures.createCanvas(key, width, height);
    tex.context.drawImage(canvas, 0, 0);
    tex.refresh();
  }

  private createGlowParticle(key: string, size: number) {
    const canvas = document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    const ctx = canvas.getContext('2d')!;
    const gradient = ctx.createRadialGradient(size, size, 0, size, size, size);
    gradient.addColorStop(0, 'rgba(0, 240, 255, 0.8)');
    gradient.addColorStop(0.5, 'rgba(0, 240, 255, 0.2)');
    gradient.addColorStop(1, 'rgba(0, 240, 255, 0)');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, size * 2, size * 2);

    const tex = this.textures.createCanvas(key, size * 2, size * 2);
    tex.context.drawImage(canvas, 0, 0);
    tex.refresh();
  }
}
